"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadValidationErrorResponseSchema = exports.UploadResultSchema = exports.UploadedFileSchema = exports.ValidationWarningSchema = exports.ValidationErrorSchema = exports.ValidationWarningCode = exports.ValidationErrorCode = void 0;
const zod_1 = require("zod");
const CadTool_1 = require("../DesignModels/CadTool");
exports.ValidationErrorCode = zod_1.z.enum([
    'FILE_TOO_LARGE',
    'TOTAL_SIZE_EXCEEDED',
    'TOO_MANY_FILES',
    'INVALID_FILENAME',
    'PATH_TRAVERSAL',
    'PATH_TOO_DEEP',
    'PATH_TOO_LONG',
    'BLOCKED_EXTENSION',
    'MISSING_REQUIRED_FILE',
    'UNRECOGNIZED_PROJECT_TYPE',
    'MIXED_PROJECT_TYPES',
]);
exports.ValidationWarningCode = zod_1.z.enum(['EMPTY_DIRECTORY', 'UNUSUAL_STRUCTURE']);
exports.ValidationErrorSchema = zod_1.z.object({
    path: zod_1.z.string(),
    code: exports.ValidationErrorCode,
    message: zod_1.z.string(),
});
exports.ValidationWarningSchema = zod_1.z.object({
    path: zod_1.z.string(),
    code: exports.ValidationWarningCode,
    message: zod_1.z.string(),
});
exports.UploadedFileSchema = zod_1.z.object({
    id: zod_1.z.string(),
    relativePath: zod_1.z.string(),
    size: zod_1.z.number(),
    mimeType: zod_1.z.string(),
});
exports.UploadResultSchema = zod_1.z.object({
    success: zod_1.z.literal(true),
    uploadId: zod_1.z.string(),
    files: zod_1.z.array(exports.UploadedFileSchema),
    cadTool: CadTool_1.CadToolSchema.nullable(),
    warnings: zod_1.z.array(exports.ValidationWarningSchema),
});
exports.UploadValidationErrorResponseSchema = zod_1.z.object({
    success: zod_1.z.literal(false),
    errors: zod_1.z.array(exports.ValidationErrorSchema),
    warnings: zod_1.z.array(exports.ValidationWarningSchema),
});
//# sourceMappingURL=upload-types.js.map